export default __webpack_public_path__ + "static/media/portfolio-hover-162.347f938e.jpg";